import React, { Component } from "react";
import { languages } from "../../../constants/languages";
import EditDiaDialog from "../../../components/settings/slideshow/EditDiaDialog";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";

class EditDiaContainer extends Component {
  state = {
    open: false,
    title: "",
    time: 10,
    day: "all",
  };

  toggleDialog = () => {
    this.setState({ open: !this.state.open });
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const dia = nextProps.dia;
    if (dia) {
      this.updateState(dia);
    }
  };

  updateState = (dia) => {
    this.setState({
      title: dia.title || "",
      time: dia.time,
      day: dia.day || "all",
    });
  };

  handleTitleChange = (e) => {
    this.setState({ title: e.target.value });
  };

  handleTimeChange = (e) => {
    this.setState({ time: Number(e.target.value) });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    let title = this.state.title;
    let time = this.state.time;
    let day = this.state.day;
    if (day === "all") {
      day = null;
    }

    let diaDoc = tournamentRef.collection("dias").doc();
    if (this.props.dia) {
      this.toggleDialog();
      diaDoc = tournamentRef.collection("dias").doc(this.props.dia.id);
      diaDoc.update({ title: title, time: time, day: day });
    } else {
      diaDoc.set({
        slideshow: this.props.selectedSlideshow,
        sponsorIndex: null,
        diaText: null,
        diaTextIndex: null,
        active: false,
        title: title,
        time: time,
        day: day,
        num:
          this.props.dias.length === 0
            ? 0
            : this.props.dias[this.props.dias.length - 1].num + 1,
      });
    }
  };

  handleDelete = (e) => {
    e.preventDefault();
    this.toggleDialog();
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    tournamentRef.collection("dias").doc(this.props.dia.id).delete();
  };

  handleSelectDay = (event) => {
    let newState = {};
    newState[event.target.name] = event.target.value;
    this.setState(newState);
  };

  render() {
    return (
      <div>
        {this.props.dia ? (
          <IconButton
            aria-label="Change"
            onClick={this.toggleDialog}
            style={{
              height: 20,
              width: 20,
              marginLeft: 5,
              marginRight: 5,
              color: "white",
            }}
            // disabled={this.props.dia.isPSD}
          >
            <CreateIcon
              style={{ height: 20, width: 20, position: "absolute", top: 3 }}
            />
          </IconButton>
        ) : (
          <Button
            fullWidth={!this.props.firstDia}
            variant="outlined"
            onClick={this.handleSubmit}
            size="small"
          >
            {languages.present.addDia}
          </Button>
        )}
        <EditDiaDialog
          title={this.state.title}
          time={this.state.time}
          open={this.state.open}
          dia={this.props.dia}
          toggleDialog={this.toggleDialog}
          handleTitleChange={this.handleTitleChange}
          handleChange={this.handleTimeChange}
          handleSubmit={this.handleSubmit}
          handleDelete={this.handleDelete}
          days={this.props.days}
          daysByKey={this.props.daysByKey}
          tournament={this.props.tournament}
          handleSelectDay={this.handleSelectDay}
          day={this.state.day}
        />
      </div>
    );
  }
}

export default EditDiaContainer;
